export default {"src":"/_next/static/media/cxVal1.ce18fd79.svg","height":160,"width":150,"blurWidth":0,"blurHeight":0};